import React, { Component } from 'react';
import OrderStatusBadge from 'src/components/Shared/OrderStatusBadge';
import { formatDateTime, formatAmount } from 'src/Common/utils';


export default class InfoCard extends Component {
    render() {
        const { baseAmount, totalAmount, updatedBaseAmount, createdAt, seller, status, externalOrderNumber } = this.props;
        const establishment = this.props.establishment || {};
        const terminal = this.props.terminal || {};

        return (
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Informações</h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-4">
                            <ul className="list-group list-group-flush list my--3">
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Valor c/ Juros
                                            </h5>
                                        </div>
                                        <div className="col-auto">{formatAmount(totalAmount)}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Valor s/ Juros
                                            </h5>
                                        </div>
                                        <div className="col-auto">{formatAmount(baseAmount)}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Valor s/ Juros Ajustado
                                            </h5>
                                        </div>
                                        <div className="col-auto">{formatAmount(updatedBaseAmount)}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Valor Agregado
                                            </h5>
                                        </div>
                                        <div className="col-auto">{formatAmount(totalAmount-baseAmount)}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-4">
                            <ul className="list-group list-group-flush list my--3">
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Data
                                            </h5>
                                        </div>
                                        <div className="col-auto">{formatDateTime(createdAt)}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Local
                                            </h5>
                                        </div>
                                        <div className="col-auto">{establishment.title}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Vendedor
                                            </h5>
                                        </div>
                                        <div className="col-auto">{seller.name}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-4">
                            <ul className="list-group list-group-flush list my--3">
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Número Externo
                                            </h5>
                                        </div>
                                        <div className="col-auto">{(externalOrderNumber) ? externalOrderNumber : 'N/A' }</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Terminal
                                            </h5>
                                        </div>
                                        <div className="col-auto">{terminal.logicalNumber}</div>
                                    </div>
                                </li>
                                <li className="list-group-item px-0 border-0">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">
                                                Status
                                            </h5>
                                        </div>
                                        <div className="col-auto">
                                            <OrderStatusBadge status={status} />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Details/InfoCard.js